import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { QuotaAnalyticsResponse } from './dashboard.interface';
import { mockAnalyticsQuota } from './mock/mockData';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private apiUrl = environment.api.base;

  private USE_MOCK_DATA = false;

  constructor(private http: HttpClient) { }

  getQuotaAnalytics(year: number): Observable<QuotaAnalyticsResponse> {

    if (this.USE_MOCK_DATA) {
      return of(mockAnalyticsQuota);
    }

    return this.http.get<QuotaAnalyticsResponse>(
      `${this.apiUrl}/analytics/quota/${year}`
    );
  }
}
